import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditInstitutionUser = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit Institution Note'
      fields={fields}
      apiPath={`admin/institution_notes/${props.params.institutionNoteId}`}
      successRedirectPath={`/membership/institutions/${props.params.institutionId}/notes`}
      buildMenuItems={menuItems}
    />
  )
}

export default EditInstitutionUser
